let screenFx = null;
let flashReduced = false;

export function initScreenFx(options = {}) {
  const screenFlash = options.screenFlash || document.getElementById('screenFlash') || createLayer('screenFlash');
  const damageFx = options.damageFx || document.getElementById('damageFx') || createLayer('damageFx');
  const cinematicBars = options.cinematicBars || document.getElementById('cinematicBars') || createBars();
  screenFx = { screenFlash, damageFx, cinematicBars };
  return screenFx;
}

export function flashScreen(color = 'rgba(255,255,255,0.88)', opacity = 0.32, ms = 110) {
  if (!screenFx) initScreenFx();
  if (flashReduced) return;
  screenFx.screenFlash.style.background = `radial-gradient(circle at 50% 50%, ${color}, transparent 68%)`;
  screenFx.screenFlash.style.opacity = String(opacity);
  clearTimeout(flashScreen.timer);
  flashScreen.timer = setTimeout(() => {
    screenFx.screenFlash.style.opacity = '0';
  }, ms);
}

export function setFlashReduction(enabled = false) {
  flashReduced = !!enabled;
  if (flashReduced && screenFx?.screenFlash) screenFx.screenFlash.style.opacity = '0';
}

export function updateDamageFx(health, maxHealth) {
  if (!screenFx) initScreenFx();
  const pct = Math.max(0, Math.min(0.55, (maxHealth - health) / Math.max(1, maxHealth + 15)));
  screenFx.damageFx.style.opacity = String(pct);
}

export function setCinematicBars(active) {
  if (!screenFx) initScreenFx();
  screenFx.cinematicBars.classList.toggle('active', active);
}

function createLayer(id) {
  const layer = document.createElement('div');
  layer.id = id;
  layer.style.cssText = [
    'position:fixed',
    'inset:0',
    'pointer-events:none',
    'opacity:0',
    'transition:opacity 120ms ease',
    'z-index:20',
  ].join(';');
  document.body.appendChild(layer);
  return layer;
}

function createBars() {
  const bars = document.createElement('div');
  bars.id = 'cinematicBars';
  bars.setAttribute('aria-hidden', 'true');
  bars.innerHTML = '<i></i><i></i>';
  document.body.appendChild(bars);
  return bars;
}
